import React, { useMemo } from 'react';
import i18n from 'i18n';
import { StyledSearchCategories, StyledSearchCategory } from './StyledComponents';

const config = {
  enterTo: 'last-focused',
  leaveFor: {
    right: '',
  },
};

const SECTION_NAME = 'SEARCH_CATEGORIES';

const SearchCategories = ({ onEnter }) => {
  const categories = useMemo(
    () => [
      { id: 'all', title: i18n.t('search.categories.all') },
      { id: 'films', title: i18n.t('search.categories.films') },
      { id: 'series', title: i18n.t('search.categories.series') },
      { id: 'channels', title: i18n.t('search.categories.channels') },
      { id: 'programs', title: i18n.t('search.categories.programs') },
    ],
    [],
  );
  return (
    <StyledSearchCategories sectionName={SECTION_NAME} config={config}>
      {categories.map((item, i) => {
        return (
          <StyledSearchCategory onEnter={onEnter} key={i} payload={item.id} focusOnMouseEnter>
            {item.title}
          </StyledSearchCategory>
        );
      })}
    </StyledSearchCategories>
  );
};

export default SearchCategories;
